import React from "react";

const Headline = ({ headline, sectionSlug = "", headlineStyles = {}, ...rest }) => {
  let style = {};

  switch (sectionSlug) {
    case "friday":
      style = {
        ...headlineStyles,
        fontStyle: "italic",
        fontFamily: "var(--primary-font)",
        fontWeight: "var(--semibold)",
      };
      break;
    case "your-money":
    case "best-buys":
    case "living-in-uae":
      style = { ...headlineStyles, fontFamily: "var(--secondary-font)", fontWeight: "var(--bold)" };
      break;
    case "parenting":
    case "videos":
      style = { ...headlineStyles, fontFamily: "var(--primary-font)", fontWeight: "var(--semibold)" };
      break;
    default:
      style = headlineStyles;
  }

  return (
    <h2 {...rest} style={style}>
      {headline}
    </h2>
  );
};

export default Headline;
